module.exports = __webpack_public_path__ + "img/wcfx.b71effca.jpg";